import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {
    RaikoBaseContainer,
    RaikoGridOneColumn,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoBaseCardContainer,
    RaikoTableTitleContainer,
    RaikoCustomTable,
    RaikoCustomSimpleChip,
    RaikoChipTypes,
    showErrorMessage,
    RaikoDefaultDialogPage,
    DialogSize, addNewRowToTable
} from "@moeindal/base-raiko-panel-components"
import {css} from "@emotion/css";
import React, {useEffect, useState} from "react";
import {FormService} from "../../serverService/formService/FormService";
import {convertUniversalDateToPersianDate} from "../../util/DateConvertor";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {useNavigate} from "react-router-dom";
import AddNewForm from "./AddNewForm";

export default function Forms() {
    let page = 0;
    const size = 20;
    const [numberOfItems, setNumberOfItems] = useState(0)
    const [pageCount, setPageCount] = useState(0)
    const [formTableLoading, setFormTableLoading] = useState(false)
    const [formsData, setFormsData] = useState([])

    const service = new FormService()


    useEffect(() => {
        if (typeof service !== 'undefined') {
            getFormListFromServer()
        }
    }, []);


    function formsTablePreparation(id, number, title, enabled, createdAt) {
        return {
            id: id,
            number: number,
            title: title,
            createdAt: convertUniversalDateToPersianDate(createdAt),
            enabled: enabled ? <RaikoCustomSimpleChip title={"فعال"} type={RaikoChipTypes.success}/>
                : <RaikoCustomSimpleChip title={"غیر فعال"} type={RaikoChipTypes.error}/>,
        }
    }

    function getFormListFromServer() {
        setFormTableLoading(true)
        service.getFormList(page, size).then(
            response => {
                setNumberOfItems(response.numberOfItems)
                setPageCount(response.totalPage)
                setFormsData([])
                response.data.map((item, index) => {
                    setFormsData((prevState => [
                        ...prevState,
                        formsTablePreparation(
                            item.id,
                            (page * size) + index + 1,
                            item.title,
                            item.enabled,
                            item.createdAt
                        )
                    ]))
                })
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setFormTableLoading(false)
        })
    }

    const navigate = useNavigate()

    function showFormDetail(formId) {
        let _formTitle = ""
        formsData.map((item) => {
            if (item.id === formId)
                _formTitle = item.title
        })
        navigate(RouteHelper.FormDetail.globalUrl.replace(":id", formId),
            {state: {title: _formTitle}, replace: false}
        )

    }

    //addNewForm
    const [openDialog, setOpenDialog] = useState(false)

    function handleOpenAddNewFormDialog() {
        setOpenDialog(true)
    }

    function handleCloseDialog() {
        setOpenDialog(false)
    }

    //addNewForm

    function handleAddNewFormToTable(item) {
        const items = addNewRowToTable(
            formsTablePreparation(
                item.id,
                1,
                item.title,
                item.enabled,
                item.createdAt
            ),
            formsData
        )

        handleCloseDialog()
        setFormsData(items)
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.Forms.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                pageTitle={"افزودن فرم جدید"}
                open={openDialog}
                onClose={handleCloseDialog}
                dialogSize={DialogSize.SMALL}
            >
                <AddNewForm handleAddNewFormToTable={handleAddNewFormToTable}/>
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(RouteHelper.Forms.name, "")
                        ]}
                    />
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={"فرم ها"}
                                amount={numberOfItems}
                                hasAmount={true}
                                hasCreateNewItem={true}
                                handleCreateNewItem={handleOpenAddNewFormDialog}
                            />
                            <RaikoCustomTable
                                header={columns}
                                pageCount={pageCount}
                                isLoading={formTableLoading}
                                data={formsData}
                                rowClicked={showFormDetail}
                            />
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )

}
const columns = [
    {
        id: 'number',
        label: '#',
    },
    {
        id: 'title',
        label: 'عنوان',
    },
    {
        id: 'createdAt',
        label: 'تاریخ ساخت',
    },
    {
        id: 'enabled',
        label: 'وضعیت',
    },
]